var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 245.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    d: "M32,106.67A10.67,10.67,0,0,1,24.91,88l48-42.67a10.62,10.62,0,0,1,8.37-2.61l83,10.07,47-44.56A10.66,10.66,0,0,1,226,23.74l-50.67,48a10.73,10.73,0,0,1-8.61,2.85L83.49,64.5,39.09,104a10.61,10.61,0,0,1-7.09,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    d: "M226.67,53.34A8,8,0,0,1,221,51L183.68,13.66A8,8,0,0,1,189.33,0h37.33a8,8,0,0,1,8,8V45.33a8,8,0,0,1-4.95,7.39A7.66,7.66,0,0,1,226.67,53.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M74.67,184v29.33h-64V184A13.33,13.33,0,0,1,24,170.67H61.33A13.34,13.34,0,0,1,74.67,184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M160,120v93.33H96V120a13.33,13.33,0,0,1,13.33-13.33h37.33A13.33,13.33,0,0,1,160,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    d: "M245.33,141.34v72h-64v-72A13.32,13.32,0,0,1,194.66,128H232A13.31,13.31,0,0,1,245.33,141.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    d: "M248,245.34H8a8,8,0,0,1,0-16H248a8,8,0,0,1,0,16Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.5fc8d347c0bd011c54195261fec5960d.svg";
export { ForwardRef as ReactComponent };